import React from 'react';

import { Container, Skeleton } from '@mantine/core';
import KiloAlert from 'components/KiloAlert';
import { useExistsAtLeastOneExpectation } from 'hooks/reports/utilization/package-utilization/useExpectations';

import NoExpectationsMessage from './NoExpectationsMessage';
import Table from './Table';

const TableSection = (): JSX.Element => {
  const { data: existsAtLeastOne, isLoading, isError } = useExistsAtLeastOneExpectation({});

  if (isLoading) {
    return <Skeleton height={100} />;
  }

  if (isError) {
    return (
      <Container sx={{ paddingTop: '2rem' }}>
        <KiloAlert variantStyle='error' title='Error'>
          Something went wrong while fetching data!
        </KiloAlert>
      </Container>
    );
  }

  if (!existsAtLeastOne) {
    return (
      <Container sx={{ paddingTop: '2rem' }}>
        <NoExpectationsMessage />
      </Container>
    );
  }

  return <Table />;
};

export default TableSection;
